import { FIRM_WATERFALL_PAGE_TITLE } from 'common/constants/user';
import { useSecondaryNavigationRegistration } from 'context/FirmBaseLayoutContext';
import WaterfallDisplay from 'pages/Waterfall/WaterfallDisplay/WaterfallDisplay';

const FIRM_WATERFALL_SECONDARY_NAVIGATION = {
  title: FIRM_WATERFALL_PAGE_TITLE,
};

const FirmWaterfall = () => {
  useSecondaryNavigationRegistration(FIRM_WATERFALL_SECONDARY_NAVIGATION);

  return <WaterfallDisplay isFirmPage />;
};

export default FirmWaterfall;
